import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { notificationApi } from '../../services/notification';

interface NotificationState {
  unreadCount: number;
  selectedNotification: any | null;
  filters: {
    isRead: boolean | null;
  };
  pagination: {
    page: number;
    limit: number;
  };
  isLoading: boolean;
  error: string | null;
}

const initialState: NotificationState = {
  unreadCount: 0,
  selectedNotification: null,
  filters: {
    isRead: null,
  },
  pagination: {
    page: 1,
    limit: 10,
  },
  isLoading: false,
  error: null,
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setUnreadCount: (state, action: PayloadAction<number>) => {
      state.unreadCount = action.payload;
    },
    decrementUnreadCount: (state) => {
      if (state.unreadCount > 0) {
        state.unreadCount -= 1;
      }
    },
    incrementUnreadCount: (state) => {
      state.unreadCount += 1;
    },
    setSelectedNotification: (state, action: PayloadAction<any | null>) => {
      state.selectedNotification = action.payload;
    },
    setFilters: (state, action: PayloadAction<Partial<NotificationState['filters']>>) => {
      state.filters = { ...state.filters, ...action.payload };
      state.pagination.page = 1;
    },
    setPagination: (state, action: PayloadAction<Partial<NotificationState['pagination']>>) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearNotification: (state) => {
      state.selectedNotification = null;
      state.error = null;
    },
    resetFilters: (state) => {
      state.filters = {
        isRead: null,
      };
      state.pagination.page = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        notificationApi.endpoints.getNotifications.matchPending,
        (state) => {
          state.isLoading = true;
          state.error = null;
        }
      )
      .addMatcher(
        notificationApi.endpoints.getNotifications.matchFulfilled,
        (state) => {
          state.isLoading = false;
        }
      )
      .addMatcher(
        notificationApi.endpoints.getNotifications.matchRejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.error.message || 'Помилка завантаження сповіщень';
        }
      )
      .addMatcher(
        notificationApi.endpoints.markAsRead.matchFulfilled,
        (state) => {
          state.unreadCount -= 1;
        }
      )
      .addMatcher(
        notificationApi.endpoints.markAllAsRead.matchFulfilled,
        (state) => {
          state.unreadCount = 0;
        }
      );
  },
});

export const {
  setUnreadCount,
  decrementUnreadCount,
  incrementUnreadCount,
  setSelectedNotification,
  setFilters,
  setPagination,
  setLoading,
  setError,
  clearNotification,
  resetFilters,
} = notificationSlice.actions;

export default notificationSlice.reducer; 